<div class="welcome-item"(click)="goToEditUser()">
  <p class="link1">Welcome, {{ name }}</p>
</div>
